import React, { useEffect } from "react";
import { RootState, useAppSelector } from "../store";

import { CoursesResponse } from "../api/api-model";
import ModalBase from "./ModalBase";
import { useModal } from "../context/ModalContext";

interface NewCourseData {
  uid: string;
}

interface NewCourseModalProps {
  onConfirm: (data: NewCourseData) => void;
}

export default function NewCourseModal(props: NewCourseModalProps) {
  const { onConfirm } = props;
  const { hideModal } = useModal();
  const [data, setData] = React.useState<NewCourseData>({ uid: "" });
  const coursesResponse: CoursesResponse | null = useAppSelector(
    (state: RootState) => state.admin.coursesResponse
  );
  const user = useAppSelector((state: RootState) => state.admin.selectedUser);
  const inUse = React.useMemo(() => Object.keys(user?.courses || {}), [user]);
  const [courses, setCourses] = React.useState<{ uid: string; name: string }[]>(
    []
  );

  useEffect(() => {
    if (coursesResponse) {
      setCourses(
        coursesResponse.courses
          .filter((c) => !inUse.includes(c.uid))
          .map((course) => ({
            uid: course.uid,
            name: course.name,
          }))
      );
    }
  }, [coursesResponse, inUse]);

  const handleConfirm = () => {
    onConfirm(data);
    hideModal();
  };

  const handleCancel = () => {
    hideModal();
  };

  return (
    <ModalBase
      header="Select a course to add"
      body={
        <>
          <select
            value={data.uid}
            onChange={(e) => setData({ ...data, uid: e.target.value })}
          >
            <option value="">Select a course</option>
            {courses.map((course) => (
              <option key={course.uid} value={course.uid}>
                {course.name}
              </option>
            ))}
          </select>
        </>
      }
      footer={
        <>
          <button
            className="loa-button loa-button-secondary"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className="loa-button loa-button-primary"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </>
      }
    />
  );
}
